import Ably from 'ably';
import enviro from 'enviro';
const PULL_WORKER_QUEUE_NAME_SUFFIX_KEY = 'PULL_WORKER_QUEUE_NAME_SUFFIX';
const BREEZE_ASSISTANT_INCLUDE_CHIRP_TOOL_KEY = 'BREEZE_ASSISTANT_INCLUDE_CHIRP_TOOL';
const BREEZE_ASSISTANT_REASONING_MODEL_KEY = 'BREEZE_ASSISTANT_REASONING_MODEL';

/**
 * Used for backend engineers to be able to run their own chats through their own local pull worker
 */
export const getPullWorkerQueueNameSuffix = () => {
  if (!enviro.isProd()) {
    try {
      const suffix = localStorage.getItem(PULL_WORKER_QUEUE_NAME_SUFFIX_KEY);
      return suffix && suffix.length > 0 ? suffix : null;
    } catch (e) {
      return null;
    }
  }
  return null;
};

/**
 * Get the CHIRP tool FQCNs from local storage for Breeze assistant
 */
export const getBreezeAssistantChirpToolsFromLocalStorage = () => {
  if (!enviro.isProd()) {
    try {
      const value = localStorage.getItem(BREEZE_ASSISTANT_INCLUDE_CHIRP_TOOL_KEY);
      if (!value || value.length === 0) {
        return null;
      }

      // Split by comma and trim whitespace
      return value.split(',').map(tool => tool.trim()).filter(tool => tool.length > 0);
    } catch (e) {
      return null;
    }
  }
  return null;
};

/**
 * Get the reasoning model from local storage for Breeze assistant
 */
export const getBreezeAssistantReasoningModelFromLocalStorage = () => {
  if (!enviro.isProd()) {
    try {
      const value = localStorage.getItem(BREEZE_ASSISTANT_REASONING_MODEL_KEY);
      return value && value.length > 0 ? value : null;
    } catch (e) {
      return null;
    }
  }
  return null;
};
const getMaybeDebugData = () => {
  const queueSuffix = getPullWorkerQueueNameSuffix();
  return queueSuffix ? {
    debug: {
      localQueueSuffix: queueSuffix
    }
  } : {};
};

/**
 * Create a custom Ably client with enhanced channels that apply default publish options
 */
export const createEnhancedAblyClient = clientOptions => {
  const client = new Ably.Realtime(clientOptions);
  const originalGet = client.channels.get;
  client.channels.get = function (channelName, channelOptions) {
    const channel = originalGet.call(this, channelName, channelOptions);

    // Check if this channel has already been enhanced
    if (channel.__enhanced) {
      return channel;
    }

    // Store the truly original publish method
    const originalPublish = channel.publish.bind(channel);
    channel.publish = function (name, data, callback) {
      const enhancedData = Object.assign({}, getMaybeDebugData(), data);

      // Call the bound original method directly
      return originalPublish(name, enhancedData, callback);
    };

    // Mark this channel as enhanced
    channel.__enhanced = true;
    return channel;
  };
  return client;
};